import React, { useContext } from "react";
import { AuthContext } from "../../../../context/AuthContext";
type List = {
  subheading: string;
  des: string;
};

type Task1Type = {
  heading: string;
  text: string;
  list: List[];
  listcolor: string;
  listStyleColor: string;
};

const Task1 = ({ heading, text, list, listcolor, listStyleColor }: Task1Type) => {
  const dataContext = useContext(AuthContext);

  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <div className={theme === 'dark' ? `bg-white transition-all duration-500` : "bg-black text-white transition-all duration-500"}>
      <div className="max-w-screen-2xl mx-auto px-5 lg:px-20 py-8 lg:py-20">
        <div className="">
          <h1 className="text-3xl font-bold font-montserrat mb-2">{heading}</h1>
          <p className="font-gtAmerica text-lg mb-7">{text}</p>
          <ul>
            {list.map((item, index) => (
              <div className="flex items-center gap-4" key={index}>
                <span>
                  <svg
                    width="33"
                    height="17"
                    viewBox="0 0 33 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 0H26L33 8.5L26 17H0L7 8.5L0 0Z"
                      className={`${listStyleColor}`}
                    />
                  </svg>
                </span>{" "}
                <li className="text-lg font-gtAmerica">
                  <span className={`font-bold ${listcolor} `}>
                    {item.subheading}
                  </span>
                  {item.des}
                </li>
              </div>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Task1;
